<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row">
  <div class="col text-center"><h5 class="new_project mb-3">Edit Project</h5>
  </div>
</div>

        <div class="card">
          <div class="card-body">

  <div class="row mb-3 mb-md-0">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label class="form-label">Project Name</label>
    <input id="title" type="title" placeholder="Name your project" class="form-control" name="title" v-model="title">
  </div>
  
    </div>
    <div class="col-12 col-md-3">
      <label class="form-label">Project Type</label>
      <select class="form-select" v-model="category">
      <option :value="project.category.id" disabled selected hidden>{{project.category.name}}</option>
      <option v-for="(category, index) in categories" :key="index" :value="category.id">{{category.name}}</option>
      </select>
      <!-- <v-select
        :clearable="false"
        v-model.trim="category"
        class="select-box"
        :options="categories"
        label="name">
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>
      </v-select> -->
    </div>

    <div class="col-12 col-md-3">
      <label class="form-label">Budget</label>
      <select class="form-select" v-model="budget">
      <option :value="project.budget" disabled selected hidden>{{formattedPrice(project.budget)}}</option>
      <option v-for="(budget, index) in budgets" :key="index" :value="budget.value">{{budget.name}}</option>
      </select>
      <!-- <v-select
        :clearable="false"
        v-model.trim="category"
        class="select-box"
        :options="categories"
        label="name">
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>
      </v-select> -->
    </div>
  </div>
          <label class="form-label">Description</label>
          <textarea class="form-control shadow-none inputbox" rows="10" placeholder="Describe your project here" v-model="description"></textarea>

    <div class="mb-2 mt-3">
            <button v-if="!sending"
            @click="formSubmit"
              type="button"
              class="btn btn-danger py-1 shadow-none col py-2"
              style="">Update Project</button> 

              <button v-else
              type="button"
              class="btn btn-success py-1 shadow-none col py-2"
              style="">
              <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Updating project ...</button>
    </div>

    
            <div>
              </div>
          </div>
        </div>
        </div>
      </div>
    </div>

</template> 

<script>
import "vue-select/dist/vue-select.css";

export default {
  props: ['project'], 

  data() {
    return {
      description: '',
      title: '',
      budget: 0,
      category: 0,
      sending: false,
      sent: false,
      categories: [],
      budgets: [],
      // budgets: [{ value: 5, name: '$ 5.00'}],
      loading_categories: false,
    };
  },

  created() {
    this.title = this.project.title;
    this.description = this.project.description;
    this.category = this.project.category.id;
    this.budget = this.project.budget;
    this.getCategories();
    this.populateBudgets();
  },

  methods: {

    populateBudgets() {

      let start = 50;
      let end   = 20000;
      let increment = 10;

      for (var i = start; i <= end; i+=increment) {
        var row = { value: i, name: this.formattedPrice(i) }
        this.budgets.push(row);
      }

    },

    getCategories() {
      this.loading_categories = true;

      axios.get("/categories/services").then((response) => {
        this.categories = response.data;
        this.loading_categories = false;
      });
    },

    async formSubmit() {

      if (this.new_title =='') { 

        this.sweetfire('Please enter a name for your project');

        } else if (this.category == 0) {

        this.sweetfire('Please choose a project type');
        
        } else if (this.new_description =='') {

        this.sweetfire('Please describe you project requirements');
        
        }  else {

        this.sending = true;

        let existingObj = this;

        await axios
          .post('/projects/create', {
            id: this.project.id,
            title: this.title, 
            description: this.description, 
            budget: this.budget,
            service_category_id: this.category,
            update: true})
          .then(function (response) {

            window.open('/projects/view/' + existingObj.project.id + '/0', "_self");

          })
          .catch(function (err) {
            console.log(err);
            existingObj.sending = false;
          });

      } 

    },
    
    removeImage(e) {
     
     this.file = '';
     this.filename = '';
    
    },

    showToaster(text) {
      this.$toaster.success(text, { timeout: 2000 });
    },

    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
    
  }


}
</script>

<style scoped>
.btn {border-radius:5px !important;}
select.form-select:hover {
  cursor: pointer !important;
}

select.form-select:focus {
  box-shadow: none !important;
  outline: none !important;
}

select.form-select {
  word-wrap: normal;
  width: 100%;
  border: none;
  border-radius: 5px;
  padding: 0.35rem 1.5rem;
  font-size: 1rem;
  appearance:none;
}

.alert-secondary {
  background-color: #ffffff
}
input.form-control, input.form-control:focus {
  padding: 0.35rem 1.6rem;
  background-color: #fff;
  color: #111;
  border-radius:5px !important;
  font-size: 1rem;
}
.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem 1.25rem 0.7rem 1.25rem;
  background-color: #272c35;
  border-radius: 20px;
  color: #fff;
}
.attachment { font-size: 0.9rem;}
.remove {padding: 0.2rem 0.4rem; margin-bottom:0.1rem;}
.remove:hover {cursor: pointer;}
.btn-primary-outline {
  background-color: transparent;
  border:none;
  font-size: 0.9rem;
  color: #fff;
}
.online-status{font-size: 1rem;}
.section-title{padding: 0.4rem 0.8rem;}
.notification-subject {
  font-size: 1.5em;
  color: #101a34;
  font-weight: bold;
}
.notification-description {
  font-size: 0.9rem;
  color: #3d3d3d;
  padding-left: 0;
  line-height: 1rem;
  padding-bottom:0.1rem;
}
.notification-time {
  font-size: 0.8em;
}

time {
    color: #272727;
}
.notification-sender{font-weight:bold;color:#414141;}
.notifications-row:hover{background:#f8f8f8;}
.notifications-row {border:1px solid rgb(230, 230, 230);border-radius:5px; margin-bottom:5px;padding-right:10px; margin-top:1rem;background:#f8f8f8;}
a.d-flex {text-decoration:none;}
a.d-flex:hover {color:#fff !important; }

.inputbox{resize: none;}
td:hover {
  cursor: pointer;
}
.application_image {
  width: 100%;
  border-radius: 0.25rem;
  margin-right: 0.8rem;
}
.online {
  color: #28a745;
}
.offline {
  color: #1c2b33;
}

.chatbox {
  height: 25vh;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  background: #f1f3f4;
  border-bottom: 0;
  border-top: 1px solid #dee2e6 !important;
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}


</style>